import type { FeatureGroup } from '../../../types';
import { CRM_INTEGRATIONS_FEATURE_GROUP } from '../group';

export const DATA_BRIDGE_FEATURE_GROUP: FeatureGroup = {
  guid: '61f1f20e-9f8b-43a3-8160-caeee55fff00',
  name: 'data-bridge',
  description: 'Data Bridge app — sync records between Altru and external destinations',
  product: 'app',
  parentGuid: CRM_INTEGRATIONS_FEATURE_GROUP.guid,
};
